import {
  Card,
  LearningCardsVariants
} from 'UI/'
import { CourseNeutralPath } from 'navigation/Routes'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

/** To update when working on LP */
export const CardTypes = {
  bought: 'bought',
  history: 'history',
  continueCourse: 'continueCourse',
  startCourse: 'startCourse',
  discoverCourse: 'discoverCourse',
  certificat: 'certificat',
  historyCompletedCourses: 'historyCompletedCourses'
}
/** */

export default ({ course, onCardClick, handleDeleteClick, handleIconClick, showDelete, cardType, loading, dataTest, actionButtonHeight, titleAs }) => {
  const {
    card,
    anchorClass
  } = useStyles()

  switch (cardType) {
    case LearningCardsVariants.bought:
      return (
        <a href={course?.slug ? `${CourseNeutralPath}/${course?.slug}` : null} className={anchorClass} onClick={e => e.preventDefault()}>
          <Card
            className={card}
            {...course}
            handleCardClick={onCardClick}
            onDeleteClick={handleDeleteClick}
            showDelete={showDelete}
            loading={loading}
            dataTest={dataTest}
            titleAs={titleAs}
            variant={cardType}
            progression={course?.progress}
          />
        </a>
      )
    case LearningCardsVariants.history:
      return (
        <a href={course?.slug ? `${CourseNeutralPath}/${course?.slug}` : null} className={anchorClass} onClick={e => e.preventDefault()}>
          <Card
            className={card}
            {...course}
            handleCardClick={course.progress === 100 ? null : onCardClick}
            handleIconClick={course.progress === 100 ? handleIconClick : null}
            loading={loading}
            dataTest={dataTest}
            titleAs={titleAs}
            variant={course.progress === 100 ? LearningCardsVariants.certificat : LearningCardsVariants.bought}
            progression={course?.progress}
          />
        </a>
      )
    case LearningCardsVariants.certificat:
      return (
        <a href={course?.slug ? `${CourseNeutralPath}/${course?.slug}` : null} className={anchorClass} onClick={e => e.preventDefault()}>
          <Card
            className={card}
            {...course}
            handleCardClick={onCardClick}
            handleIconClick={handleIconClick}
            loading={loading}
            dataTest={dataTest}
            titleAs={titleAs}
            variant={cardType}
          />
        </a>
      )
    case LearningCardsVariants.favorits:
      return (
        <a href={course?.slug ? `${CourseNeutralPath}/${course?.slug}` : null} className={anchorClass} onClick={e => e.preventDefault()}>
          <Card
            className={card}
            {...course}
            handleCardClick={onCardClick}
            handleIconClick={handleIconClick}
            loading={loading}
            dataTest={dataTest}
            titleAs={titleAs}
            variant={cardType}
          />
        </a>
      )
    default:
      return (
        <Card
          className={card}
          loading
          withSkeletonLastLine={false}
        />
      )
  }
}
